import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ZefReactiveComponent } from '@zerops/zef/core';
import { select, Store } from '@ngrx/store';
import { selectZefDialogState, zefDialogClose } from '@zerops/zef/dialog';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { formValueOnValid } from '@zerops/zef/forms';
import { ClientEntity } from '@zerops/zerops/core/client-base';
import { ClientAddForm } from './client-add.form';
import { FEATURE_NAME } from './client-add-dialog.constant';

@Component({
  selector: 'z-client-add-dialog',
  templateUrl: './client-add-dialog.container.html',
  styleUrl: './client-add-dialog.container.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClientAddDialogFeature extends ZefReactiveComponent {
  // # Deps
  #store = inject(Store);
  #form = inject(ClientAddForm);
  #client = inject(ClientEntity);

  // # Event Streams
  onSubmit$ = new Subject<void>();
  onClose$ = new Subject<void>();

  // # Data
  // -- sync
  addClientKey = this.#client.addOne.type;

  // -- async
  dialogState$ = this.#store.pipe(select(selectZefDialogState(FEATURE_NAME)));
  open$ = this.dialogState$.pipe(map((data) => data.state));

  formState$ = this.#form.state$;

  // # State resolver
  state = this.$connect({
    open: this.open$,
    formState: this.formState$
  });

  constructor() {
    super();

    // # Dispatcher
    this.$dispatchActions([
      this.onClose$.pipe(map(() => zefDialogClose({ key: FEATURE_NAME }))),

      this.onSubmit$.pipe(
        formValueOnValid(this.#form),
        map((formValue) => this.#client.addOne({ accountName: formValue.name }))
      )
    ]);
  }
}
